import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Logo from './logo';
import api from '../config/axios';
import { isSuperAdmin } from '../utils/jwt.utils';

const Menu: React.FC = () => {
    
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);

    const navigate = useNavigate();    

    useEffect(() => {
        const token = sessionStorage.getItem('accessToken');
        setIsLoggedIn(!!token);
    }, []);
   
    const handleLogout = () => {
        sessionStorage.removeItem('accessToken');
        setIsLoggedIn(false);
        navigate('/');
    };

    useEffect(() => {
        const fetchUnreadCount = async () => {
            const token = sessionStorage.getItem('accessToken');           
           
            if (!token) {
                setUnreadCount(0);
                return;
            }
            
            
            try {
                const response = await api.get('/messages/unread-count');
                const count = Number(response.data.count);
                setUnreadCount(!isNaN(count) ? count : 0);
            } catch (error) {
                console.error('Erreur lors de la récupération des messages non lus');
                setUnreadCount(0);
            }
        };
    
        if (isLoggedIn) {
            fetchUnreadCount();
        }
    }, [isLoggedIn]);


    return (
        <nav className="bg-white shadow-lg mb-4">
            <div className="max-w-7xl mx-auto">
                <div className="flex justify-between items-center h-24">
                    {/* Logo */}
                    <div className="flex-shrink-0">
                        <a href="/" className="text-2xl font-bold">
                        <div>
                          <Logo />
                        </div>
                        </a>
                    </div>

                    {/* Mobile menu button */}
                    <div className="md:hidden">
                        <button
                            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                            className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-orange-500"
                        >
                            <span className="sr-only">Ouvrir menu</span>
                            {!isMobileMenuOpen ? (
                                <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                            ) : (
                                <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            )}
                        </button>
                    </div>

                    {/* Desktop menu */}
                    <div className="hidden md:flex md:items-center md:space-x-4">
                        <ul className="flex space-x-4 items-center">                                                    
                            <li className="hover:text-orange-400">
                                <a href="/tournois">Trouver un tournoi</a>
                            </li>
                            <li className="hover:text-orange-400">
                                <a href="/partenaires">
                                    Trouver un partenaire
                                </a>
                            </li>
                           {/* <li className="hover:text-orange-400">
                                <a href="/annonces">
                                    Le coin des annonces
                                </a>
                            </li>*/}
                            {isLoggedIn ? (
                                <>
                                    
                                    <li className="hover:text-orange-400">
                                        <a href="/compte">Mon compte</a>
                                    </li>
                                    <Link to="/messages" className="relative">
                                        Messages
                                        {unreadCount > 0 && (
                                            <span className="absolute top-0 right-0 bg-red-500 text-white rounded-full text-xs px-2">
                                                {unreadCount}
                                            </span>
                                        )}
                                    </Link>
                                    {isSuperAdmin() && (
                                        <li className="hover:text-orange-400">
                                            <a href="/admin" className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition">
                                                🔐 Admin
                                            </a>
                                        </li>
                                    )}
                                    <li className="hover:text-orange-400">
                                        <button
                                            onClick={handleLogout}
                                            className="bg-orange-500 text-white px-4 py-2 rounded-lg hover:bg-orange-600 transition"
                                        >
                                            Déconnexion
                                        </button>
                                    </li>
                                </>
                            ) : (
                                <>
                                    <li className="hover:text-orange-400">
                                        <a href="/login" className="bg-orange-500 text-white px-4 py-2 rounded-lg hover:bg-orange-600 transition">
                                            Connexion
                                        </a>
                                    </li>
                                    <li className="hover:text-orange-400">
                                        <a href="/signup" className="px-4 py-2 rounded-lg hover:bg-gray-200 transition">
                                            Créer un compte
                                        </a>
                                    </li>
                                </>
                            )}
                        </ul>
                    </div>
                </div>

                {/* Mobile menu */}
                <div className={`${isMobileMenuOpen ? 'block' : 'hidden'} md:hidden`}>
                    <div className="pt-2 space-y-1 bg-orange-300">
                        <ul>    
                            <li>
                                <a href="/tournois" className="block px-3 py-2 rounded-md text-base font-medium text-white hover:bg-orange-400 ">
                                    Trouver un tournoi
                                </a>
                                <hr className="h-px bg-gray-200 border-0 dark:bg-gray-700"></hr>
                            </li>
                            <a href={isLoggedIn ? "/partenaires" : "/premium"}>
                                <li className="block px-3 py-2 font-medium text-white hover:bg-orange-400">                                    
                                        Trouver un partenaire
                                </li>
                                <hr className="h-px bg-gray-200 border-0 dark:bg-gray-700"></hr>
                            </a>
                            {/*<a href="/annonces">
                                <li className="block px-3 py-2 font-medium text-white hover:bg-orange-400">                                    
                                    Le coin des annonces
                                </li>
                                <hr className="h-px bg-gray-200 border-0 dark:bg-gray-700"></hr>
                            </a>*/}
                        {isLoggedIn ? (
                            <>                                                                    
                                    <hr className="h-px bg-gray-200 border-0 dark:bg-gray-700"></hr>
                                    <a href="/compte">
                                        <li className="block px-3 py-2 font-medium text-white hover:bg-orange-400">
                                                Mon compte
                                        </li>
                                    </a>
                                    <hr className="h-px bg-gray-200 border-0 dark:bg-gray-700"></hr>
                                    <Link to="/messages">
                                        <li className="block px-3 py-2 font-medium text-white hover:bg-orange-400">
                                            Messages
                                            {unreadCount > 0 && (
                                                <span className="absolute top-0 right-0 bg-red-500 text-white rounded-full text-xs px-2">
                                                    {unreadCount}
                                                </span>
                                            )}
                                        </li>
                                    </Link>
                                    {isSuperAdmin() && (
                                        <>
                                            <hr className="h-px bg-gray-200 border-0 dark:bg-gray-700"></hr>
                                            <a href="/admin">
                                                <li className="block px-3 py-2 font-medium text-yellow-300 hover:bg-orange-400">
                                                    🔐 Admin
                                                </li>
                                            </a>
                                        </>
                                    )}
                                    <hr className="h-px bg-gray-200 border-0 dark:bg-gray-700"></hr>
                                <button
                                    onClick={handleLogout}
                                    className="w-full text-left px-3 py-2 rounded-md text-base font-medium text-red-600  hover:bg-orange-400"
                                >
                                    Déconnexion
                                </button>
                            </>
                        ) : (
                            <>
                            <li>
                                <a href="/login" className="block px-3 py-2 rounded-md text-base font-medium text-white hover:bg-orange-400">
                                    Connexion
                                </a>
                            </li>
                                <hr className="h-px bg-gray-200 border-0 dark:bg-gray-700"></hr>
                            <li>
                                <a href="/signup" className="block px-3 py-2 rounded-md text-base font-medium text-white hover:bg-orange-400">
                                    Créer un compte
                                </a>
                            </li>
                            </>
                        )}
                        </ul>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Menu;